import $ from 'jquery'

export default {
	name: 'rompre-contrat',
	components: {},
	props: {
		societe_id: String
	},
	data () {
		return {
			save_loading: false
		}
	},
	computed: {

	},
	mounted () {

	},
	methods: {
		/**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

		rompreContrat() {
			this.save_loading = true;
			let confirm = document.getElementById('cfrm-rupture');
			
			if (confirm.checked == false) {     //  Vérifie si l'utilisateur a confirmé avoir effectuer le traitement
				$('.err-msg').fadeIn(500)
				
				this.save_loading = false;
				return;
			}

	console.log("delete contrat de societe ",parseInt(this.societe_id))
            this.$store.dispatch("deleteContrat", parseInt(this.societe_id)).then((response) => {
				console.log(response)
				this.save_loading = false;

				this.$refs.close_modal.click()
				this.$store.dispatch("getSociete", parseInt(this.societe_id))
			})
        },
	}
}


